import {
  format as fnsFormat,
  //   differenceInHours as fnsDifferenceInHours,
  //   differenceInMinutes as fnsDifferenceInMinutes,
} from "date-fns";
import {
  format as tzFormat,
  utcToZonedTime,
  zonedTimeToUtc,
} from "date-fns-tz";
import {
  TIMEZONE_MODES,
  TIME_FORMAT,
  getTimezoneOptionsCache,
} from "../helpers";

export const getNewDateTimeTz = (date: Date | string | number) => {
  const timezone = getTimezoneOptionsCache();
  const newDate = new Date(date);

  if (timezone.enabled && timezone.mode === TIMEZONE_MODES.UTC_TO_ZONED_TIME) {
    const zonedTime = utcToZonedTime(newDate, timezone.zone);
    return zonedTime.getTime();
  }

  return newDate.getTime();
};

export const getNewDateTz = (date?: Date | string | number) => {
  const timezone = getTimezoneOptionsCache();
  const newDate = date ? new Date(date) : new Date();

  if (timezone.enabled && timezone.mode === TIMEZONE_MODES.UTC_TO_ZONED_TIME) {
    const zonedTime = utcToZonedTime(newDate, timezone.zone);
    return zonedTime;
  }

  return newDate;
};

export const formatTz = (
  date: Date | number,
  formatTime: string = TIME_FORMAT.DEFAULT
) => {
  const timezone = getTimezoneOptionsCache();
  if (timezone.enabled && timezone.mode === TIMEZONE_MODES.UTC_TO_ZONED_TIME) {
    const zonedTime = utcToZonedTime(date, timezone.zone);
    const formattedZonedTime = tzFormat(zonedTime, formatTime, {
      timeZone: timezone.zone,
    });
    return formattedZonedTime;
  }

  return fnsFormat(date, formatTime);
};

export const zonedDateTimeToUtc = (date: Date) => {
  const timezone = getTimezoneOptionsCache();
  if (timezone.enabled && timezone.mode === TIMEZONE_MODES.UTC_TO_ZONED_TIME) {
    const zonedTime = zonedTimeToUtc(date, timezone.zone);
    return zonedTime;
  }

  return date;
};
